module.exports = __webpack_public_path__ + "static/media/singapore-01.9bd6950c.png";